import { render, staticRenderFns } from "./defaultForm.vue?vue&type=template&id=4337554c&scoped=true&"
import script from "./defaultForm.vue?vue&type=script&lang=ts&"
export * from "./defaultForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4337554c",
  null
  
)

export default component.exports